import type { IGAEntitlement } from '../types';

export type EntitlementRiskLevel = 'Low' | 'Medium' | 'High' | 'Critical';

const STANDARD_LEVELS = new Set<EntitlementRiskLevel>(['Low', 'Medium', 'High', 'Critical']);

export function isStandardRiskLevel(risk?: string | null): risk is EntitlementRiskLevel {
  return STANDARD_LEVELS.has(String(risk || '').trim() as EntitlementRiskLevel);
}

export function normalizeEntitlementRiskLevel(risk?: string | null): EntitlementRiskLevel {
  const trimmed = String(risk || '').trim();
  if (isStandardRiskLevel(trimmed)) return trimmed;

  switch (trimmed.toLowerCase()) {
    case 'low':
      return 'Low';
    case 'medium':
      return 'Medium';
    case 'high':
      return 'High';
    case 'critical':
      return 'Critical';
    default:
      return 'Medium';
  }
}

/** Entitlement risk is inherited from the linked application when it has a standard tier. */
export function resolveEntitlementRiskLevel(
  applicationRisk?: string | null,
  entitlementRisk?: string | null,
): EntitlementRiskLevel {
  if (isStandardRiskLevel(applicationRisk)) {
    return normalizeEntitlementRiskLevel(applicationRisk);
  }
  return normalizeEntitlementRiskLevel(entitlementRisk);
}

export function displayEntitlementRisk(
  entitlement: Pick<IGAEntitlement, 'risk_level' | 'application_id'> & { application_risk_level?: string },
  applicationRiskById?: ReadonlyMap<string, string | undefined>,
): EntitlementRiskLevel {
  const applicationRisk =
    entitlement.application_risk_level ?? applicationRiskById?.get(entitlement.application_id);
  return resolveEntitlementRiskLevel(applicationRisk, entitlement.risk_level);
}
